// for regain
import { MessageBox, Message } from "element-ui";
import {
  regainOrder,
  regainUnit,
  regainPhysicalCard
} from "@/services/fulfillment-api";
import {
  bookingStatusConst,
  CONST_waiting_for_regain
} from "../order-list/utils/const";

export default {
  methods: {
    // 校验是否属于 booking 层级 regain 操作
    checkBookingRegainBtn(booking) {
      let units = booking.order_unit_file;
      if (!units.length) {
        return false;
      }
      for (let i = 0; i < units.length; i++) {
        if (units[i].status !== bookingStatusConst[CONST_waiting_for_regain]) {
          return false;
        }
      }
      return true;
    },
    // regain unit or order
    async regain(row, unit) {
      await MessageBox.confirm(this.$t("ffm_regain_confirm"), "Alert", {
        type: "info"
      });
      try {
        let templateId = (row && row.order_base_info && row.order_base_info.template_id) || 0;
        console.log("regain", templateId, row);
        if (unit) {
          await regainUnit({
            order_base_id: unit.row.order_base_id,
            unit_file_id: unit.row.id
          });
        } else if (templateId == 2) {
          console.log("templateId == 2", templateId, row);
          await regainPhysicalCard({
            order_base_id: row.order_base_info_id
          });
        } else {
          await regainOrder({
            order_base_id: row.order_base_info_id
          });
        }
        Message(this.$t("ffm_operation_successful"));
        this.search();
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    },
    // 打开 regain 弹框
    handleRegain(level, row, viewOrEdit) {
      if (!level || !row || !viewOrEdit) {
        throw new Error("[func handleRegain] error: params lost");
      }

      if (level === "booking") {
        this.selectedRow = row;
      } else if (level === "unit") {
        this.selectedRow = row.row;
      }
      this.selectedLevel = level;

      const map = {
        view: "regainViewDialogVisible",
        edit: "regainEditDialogVisible"
      };
      this[map[viewOrEdit]] = true;
    },
    // 判断是否有已上传的 regain 文件
    hasRegainFilePath(level, row) {
      if (!level || !row) {
        throw new Error("[func hasRegainFilePath] error: params lost");
      }

      if (level === "booking") {
        return !!row.order_base_info.regain_file_path;
      } else if (level === "unit") {
        return !!row.regain_file_path;
      }
    }
  }
};
